/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Group_RecordingInputs */

const en_enum_setting_group_recording = /** @type {(inputs: Enum_Setting_Group_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Recording`)
};

const de_enum_setting_group_recording = /** @type {(inputs: Enum_Setting_Group_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe Recording`)
};

/**
* | output |
* | --- |
* | "Group Recording" |
*
* @param {Enum_Setting_Group_RecordingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_group_recording = /** @type {((inputs?: Enum_Setting_Group_RecordingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Group_RecordingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_group_recording(inputs)
	return de_enum_setting_group_recording(inputs)
});